import React from 'react';
import { movdFocus, movdTokens } from './movdTokens.js';

export default function MovdQuantityControl({ label, value, onDecrease, onIncrease }) {
  const buttonStyle = {
    width: 42,
    height: 42,
    border: `1px solid rgba(248,250,252,.28)`,
    borderRadius: movdTokens.radius.control,
    background: 'rgba(248,250,252,.06)',
    color: movdTokens.color.text,
    font: 'inherit',
    fontSize: 22,
    lineHeight: 1,
    cursor: 'pointer',
  };
  const focus = event => { event.currentTarget.style.outline = movdFocus.outline; };
  const blur = event => { event.currentTarget.style.outline = ''; };
  return (
    <div role="group" aria-label={`${label} quantity`} style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <button type="button" aria-label={`Decrease ${label}`} onClick={onDecrease} onFocus={focus} onBlur={blur} style={buttonStyle}>−</button>
      <output aria-live="polite" style={{ minWidth: 24, color: movdTokens.color.text, fontSize: 18, fontWeight: 900, textAlign: 'center' }}>{value}</output>
      <button type="button" aria-label={`Increase ${label}`} onClick={onIncrease} onFocus={focus} onBlur={blur} style={{ ...buttonStyle, background: movdTokens.color.teal, borderColor: movdTokens.color.teal, color: movdTokens.color.ink }}>+</button>
    </div>
  );
}
